export const headbarHeight = $state({
	value: 0,
});
